import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, FormGroup, Label, Form } from "reactstrap";
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import { FaTrashAlt } from 'react-icons/fa';
import ReportPeriod from '../ReportPeriod';
import { GetWorkorderTechnician, GetWorkOrderBuildingsList } from '../../../../../action/workorderAction';

class BuildingReportFilter extends Component {

    componentWillMount() {
        this.props.GetWorkorderTechnician();
        this.props.GetWorkOrderBuildingsList();
        if(this.props.IsEdit){
            var lFilters = this.props.SavedData, selectedBuildingId = [], selectedAssignedToId = [], selectedBuilding = [], selectedAssignedTo = [];
            var l_IsSingleBuildingSelected = false;
            if(lFilters.Building !== null){
                if(this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings !== null && this.props.getWorkOrderBuildings.length){
                    lFilters.Building.forEach(el => {
                        var data1 = this.props.getWorkOrderBuildings.filter(e => e.id === el.buildingID)[0];
                        if(data1 !== undefined && !data1.isDeleted){
                            selectedBuilding.push({"id" : el.buildingID, "value" : data1.name});
                            selectedBuildingId.push(el.buildingID);
                        }
                    })
                    l_IsSingleBuildingSelected = (lFilters.Building.length === 1 && selectedBuildingId.length === 0) ? true : false; 
                }
            }
            if(lFilters.AssignedTo !== null){
                if(this.props.getTechnicianList !== undefined && this.props.getTechnicianList !== null && this.props.getTechnicianList.length){
                    lFilters.AssignedTo.forEach(el => {
                        var data2 = this.props.getTechnicianList.filter(e => e.technicianID === el.assignedUserID)[0];
                        selectedAssignedTo.push({"id" : el.assignedUserID, "value" : data2.name});
                        selectedAssignedToId.push(el.assignedUserID);
                    })
                }
            }
            this.setState({
                SelectedAssignedTo : selectedAssignedToId,
                SelectedAssignedToList : selectedAssignedTo,
                SelectedBuilding : selectedBuildingId,
                SelectedBuildingList : selectedBuilding,
                IsSingleBuildingDeleted: l_IsSingleBuildingSelected
            }) 
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            SelectedAssignedToList: [],
            SelectedAssignedTo: [],
            SelectedBuildingList: [],
            SelectedBuilding: [],
            IsSingleBuildingDeleted: false
        }
        
        this.DeleteAssignedTo = this.DeleteAssignedTo.bind(this);
        this.DeleteBuilding = this.DeleteBuilding.bind(this);
        this.dropdown_fields = { text: 'value', value: 'id' };
    }

    onAssignedToSelect(args) { 
        var selectedAssignedToId = null;
        var l_SelectedAssignedTo = this.state.SelectedAssignedToList;
        l_SelectedAssignedTo.push(args.itemData);
        if(l_SelectedAssignedTo !== undefined && l_SelectedAssignedTo != null && l_SelectedAssignedTo.length){
            selectedAssignedToId = l_SelectedAssignedTo.map(el => ( el.id ));
        }
        this.setState({ SelectedAssignedToList : l_SelectedAssignedTo, SelectedAssignedTo : selectedAssignedToId });
        this.props.FilterSelection({"Type":"AssignedTo","Ids":l_SelectedAssignedTo});
    }

    onAssignedToRemove(args){
        var selectedAssignedToId = null;
        var l_SelectedAssignedTo = this.state.SelectedAssignedToList;
        var FilteredData = l_SelectedAssignedTo.filter(x => x.id !== args.itemData.id);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedAssignedToId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedAssignedToList : FilteredData, SelectedAssignedTo : selectedAssignedToId });
        this.props.FilterSelection({"Type":"AssignedTo","Ids":FilteredData});
    }

    DeleteAssignedTo(AssignedToId){ 
        var selectedAssignedToId = null;
        var l_SelectedAssignedTo = this.state.SelectedAssignedToList;
        var FilteredData = l_SelectedAssignedTo.filter(x => x.id !== AssignedToId);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedAssignedToId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedAssignedToList : FilteredData, SelectedAssignedTo : selectedAssignedToId });
        this.props.FilterSelection({"Type":"AssignedTo","Ids":FilteredData});
    }

    onBuildingSelect(args) { 
        var selectedBuildingId = null;
        var l_SelectedBuilding = this.state.SelectedBuildingList;
        l_SelectedBuilding.push(args.itemData);
        if(l_SelectedBuilding !== undefined && l_SelectedBuilding != null && l_SelectedBuilding.length){
            selectedBuildingId = l_SelectedBuilding.map(el => ( el.id ));
        }
        this.setState({ SelectedBuildingList : l_SelectedBuilding, SelectedBuilding : selectedBuildingId, IsSingleBuildingDeleted: false });
        this.props.FilterSelection({"Type":"Building","Ids":l_SelectedBuilding});
    }

    onBuildingRemove(args){
        var selectedBuildingId = null;
        var l_SelectedBuilding = this.state.SelectedBuildingList;
        var FilteredData = l_SelectedBuilding.filter(x => x.id !== args.itemData.id);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedBuildingId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedBuildingList : FilteredData, SelectedBuilding : selectedBuildingId });
        this.props.FilterSelection({"Type":"Building","Ids":FilteredData});
    }

    DeleteBuilding(BuildingId){ 
        var selectedBuildingId = null;
        var l_SelectedBuilding = this.state.SelectedBuildingList;
        var FilteredData = l_SelectedBuilding.filter(x => x.id !== BuildingId);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedBuildingId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedBuildingList : FilteredData, SelectedBuilding : selectedBuildingId });
        this.props.FilterSelection({"Type":"Building","Ids":FilteredData});
    }


    render() {
        //let label = this.props.getLabels;
        let preferredfields = this.props.getWorkorderPreferences;
        var Assigned_in_Select_input = [], Building_in_Select_input = [];
        var AssignedToList = [], BuildingList = [];
        var BuildingsList = [];
        var DropdownClass = this.state.IsSingleBuildingDeleted ? "customerrorhighlight" : "WO_Filter_Multi_Ddl"; 
        
        var assignedto = (preferredfields !== "" && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Assigned To" && x.display === true) : "";
        var building = (preferredfields !== "" && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Building" && x.display === true) : "";

       //Building
       if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings !== null && this.props.getWorkOrderBuildings.length > 0)
       BuildingsList = this.props.getWorkOrderBuildings.filter(el => el.isDeleted === false);
       if (BuildingsList !== undefined && BuildingsList !== null && BuildingsList.length > 0) {
       BuildingsList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase())).forEach(el => {
           Building_in_Select_input.push({ "id" : el.id, "value" : el.name });
       });
   }
   if (this.state.SelectedBuildingList !== undefined && this.state.SelectedBuildingList !== null && this.state.SelectedBuildingList.length) {
       var lstData3 = this.state.SelectedBuildingList;
       const rows = [...Array( Math.ceil(lstData3.length / 3) )];
       const productRows = rows.map( (row, idx) => lstData3.slice(idx * 3, idx * 3 + 3) );
       BuildingList = productRows.map((row, idx) => (
           <div className="row" key={idx}>    
             { row.map( product => <div key={product.id} className="col-md-2">
               <div><label className="reportsFilterlbl">{product.value}</label><FaTrashAlt style={{ color:"#676767", float:"left" }} className="Ensemble_Icon link_cursor" onClick={() => { this.DeleteBuilding(product.id) }} /></div>
             </div> )}
           </div> 
       ));
   }
         //AssignedTo
        if (this.props.getTechnicianList !== undefined && this.props.getTechnicianList !== null && this.props.getTechnicianList.length) {
            this.props.getTechnicianList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase())).forEach(el => {
                Assigned_in_Select_input.push({ "id" : el.technicianID, "value" : el.name });
            });
        }
        if (this.state.SelectedAssignedToList !== undefined && this.state.SelectedAssignedToList !== null && this.state.SelectedAssignedToList.length) {
            var lstData4 = this.state.SelectedAssignedToList;
            const rows = [...Array( Math.ceil(lstData4.length / 3) )];
            // chunk the products into the array of rows
            const productRows = rows.map( (row, idx) => lstData4.slice(idx * 3, idx * 3 + 3) );
            // map the rows as div.row
            AssignedToList = productRows.map((row, idx) => (
                <div className="row" key={idx}>    
                  {/* map products in the row as article.col-md-3 */}
                  { row.map( product => <div key={product.id} className="col-md-2">
                    <div><label className="reportsFilterlbl">{product.value}</label><FaTrashAlt style={{ color:"#676767", float:"left" }} className="Ensemble_Icon link_cursor" onClick={() => { this.DeleteAssignedTo(product.id) }} /></div>
                  </div> )}
                </div> 
            ));
        }

        return (
            <div>
                <Form className="form-visible">
                    <FormGroup row>
                        <Col sm={{ size: 12 }}>
                            <Label id="label_filters" className="reportsHeaderlbl">Filters</Label>
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Col sm={{ size: 12 }}>
                            <ReportPeriod IsEdit={this.props.IsEdit} isUnChecked={this.props.isUnChecked} FilterSelection={this.props.FilterSelection} reportSetting={this.props.reportSetting} dateValidation={this.props.dateValidation} dataValue={this.props.dataValue} />
                        </Col> 
                    </FormGroup>

                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label id="label_buildings" style={{ marginBottom: "0px" }} className="workorderlbl">{building.length > 0 ? building[0].fieldLabel : "Buildings"}</Label><br />
                            <MultiSelectComponent id="select_buildings" ref='building_in_Select_input' width='100%' cssClass={DropdownClass}
                                dataSource={Building_in_Select_input}
                                select={this.onBuildingSelect.bind(this)}
                                removed={this.onBuildingRemove.bind(this)}
                                fields={this.dropdown_fields}
                                value={this.state.SelectedBuilding}
                                mode="CheckBox"
                                showDropDownIcon={true} showSelectAll={true} enableSelectionOrder={false}
                                filterBarPlaceholder="Search" placeholder="-Select-" selectAllText="Select All" unSelectAllText="Clear All" >
                                <Inject services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                            <span hidden={!this.state.IsSingleBuildingDeleted}><Label style={{'color':'#D42D27', 'font-style':'italic','font-size':'10px','font-family':'Lato' }}><b>Selected building(s) no longer in system</b></Label></span>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{marginBottom: "20px"}}>
                        <Col sm={{ size: 12 }}>
                            {BuildingList}
                        </Col>
                    </FormGroup>


                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label id="label_assignedto" style={{ marginBottom: "0px" }} className="workorderlbl">{assignedto.length > 0 ? assignedto[0].fieldLabel : "Assigned To"}</Label><br />
                            <MultiSelectComponent id="select_assignedto" ref='assigned_in_Select_input' width='100%' cssClass="WO_Filter_Multi_Ddl"
                                dataSource={Assigned_in_Select_input}
                                select={this.onAssignedToSelect.bind(this)}
                                removed={this.onAssignedToRemove.bind(this)}
                                fields={this.dropdown_fields}
                                value={this.state.SelectedAssignedTo}
                                mode="CheckBox"
                                showDropDownIcon={true} showSelectAll={true} enableSelectionOrder={false}
                                filterBarPlaceholder="Search" placeholder="-Select-" selectAllText="Select All" unSelectAllText="Clear All" >
                                <Inject services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                        </Col>
                    </FormGroup>              
                    <FormGroup row style={{marginBottom: "20px"}}>
                        <Col sm={{ size: 12 }}>
                            {AssignedToList}
                        </Col>
                    </FormGroup>

                </Form>
            </div>
        )
    };
};

const mapStateToProps = (state) => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkorderPreferences: state.authService.workorder_user_preferencedetails,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getTechnicianList: state.WorkorderRootReducer.Technicians,
        getReportDetails: state.WorkorderRootReducer.WorkorderReportsDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        GetWorkOrderBuildingsList: () => dispatch(GetWorkOrderBuildingsList()),
        GetWorkorderTechnician: () => dispatch(GetWorkorderTechnician())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BuildingReportFilter);